export default __webpack_public_path__ + "static/media/well.4e450874.png";